<template>
    <div class="box">
      <div class="header">
        <p>勉县大数据服务中心</p>
      </div>
      <div class="msg_tx" :id="msgShow==true?'msg_tx':''">
          暂未开放
        </div>
      <div :class="allShow==1?'zhuti2':'zhuti'">
        <div class="nav" :id="allShow==1?'navss':''">
          <div @click="goMenu(1)">
            <!-- <span>亲商助企系统(融合服务)</span>
            <div>
              <p>智慧旅游平台</p>
              <p>涉农产业系统</p>
            </div>
            <div>
              <p>招商管理系统</p>
              <p>企业家</p>
            </div>
            <div>
              <p>勉县经济区划管理系统</p>
            </div> -->
          </div>
          <div class="nav2" @click="goMenu(2)">
            <!-- <span>乡村振兴资产管理系统</span>
            <div>
              <p id="nav2_p1">乡村振兴项目管理系统</p>
            </div>
            <div id="nav2_d2">
              <p>综合执法系统</p>
            </div>
            <div id="nav2_d3">
              <p id="nav_p2">重点项目管理系统</p>
              <p id="nav_p3">
                <span>综合治理系统</span>
                <span>非公党建系统</span>
              </p>
            </div> -->
          </div>
          <div class="nav3 nav2" @click="goMenu(3)">
            <!-- <span id="nav2_sp1">防返贫系统 <br> 矛盾纠纷多元化解平台</span>
            <div>
              <p id="nav2_p1" class="nav3_p2"> 应急指挥辅助决策系统</p>
            </div>
            <div id="nav2_d2">
              <p>公共卫生防控系统</p>
            </div>
            <div id="nav3_p3">
              <p>信访大数据</p>
              <p>重点人服务系统</p>
            </div> -->
          </div>
        </div>
        <div class="nav_title">
          <p @click="goMenu(1)">经济发展</p>
          <p @click="goMenu(2)">综合管理</p>
          <p @click="goMenu(3)">风险防范</p>
        </div>
        <div class="content">
          <div class="content_top"></div>
          <div class="content_center"></div>
          <div class="dmy"></div>
          <div class="content_nav">
            <div @click="clickMenu('/zhshj/#')">
              <img class="icon1" src="@/assets/index_img/icon1.png">
              <img class="icon2" src="@/assets/index_img/icon2.png">
              <img class="bqs" src="@/assets/index_img/bq.png">
              <p>勉县智慧治理平台</p>
              <span>业务中枢</span>
            </div>
            <div @click="clickMenu('/szzw/#')">
              <img class="icon1" src="@/assets/index_img/icon1.png">
              <img class="icon2" src="@/assets/index_img/icon2.png">
              <p>数字政府平台</p>
              <span>数据中枢</span>
            </div>
          </div>
          <div class="content_bottom">
            <div class="x1"></div>
            <div class="x2"></div>
            <div class="x3"></div>
            <div class="x4"></div>
            <div class="x5"></div>
            <div class="x6"></div>
            <img class="bjxk" src="@/assets/index_img/bottom.png" alt="">
            <!-- <div class="content_bottom_box"> -->
              <div class="neirong1 neirong0" @click="clickMenu('/zhshj/#')">
                <img src="../../assets/index_img/yh.png" alt="">
                <p>人口数据</p>
              </div>
              <div class="neirong1 neirong2" @click="clickMenu2('/whon-api')">
                <img src="../../assets/index_img/house.png" alt="">
                <p>市场主体数据</p>
              </div>
              <div class="neirong1 neirong3" @click="clickMenu('')">
                <img src="../../assets/index_img/map.png" alt="">
                <p>地图数据</p>
              </div>
              <div class="neirong1 neirong4" @click="clickMenu('https://172.18.50.10:6443/')">
                <img src="../../assets/index_img/tx.png" alt="">
                <p>融合通讯平台</p>
              </div>
              <div class="neirong1 neirong5" @click="clickMenu('http://219.144.95.79:9000/')">
                <img src="../../assets/index_img/hlw.png" alt="">
                <p>物联网平台</p>
              </div>
              <div class="neirong1 neirong6" @click="clickMenu('http://219.144.95.79:19008/index.html#/login?redirect=%2Fdashboard')">
                <img src="../../assets/index_img/sj.png" alt="">
                <p>数据交换平台</p>
              </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
</template>

<script>

   import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"

  export default {
    name: "Analysis2",
    components: {

    },
    data() {
      return {
        indexStyle:0,
        nowTime:'',
        date:'',
        timer:"",
        msgShow:false,
        allShow:0,
        screenWidth: document.body.clientWidth
      }
    },
    mounted() {
      // this.nowTimes();
      let that = this
      let ht = document.body.clientHeight
        if( ht >= 1070){
          that.allShow = 1
          console.log("全屏",that.allShow);
        }else{
          that.allShow = 0
          console.log("全屏0",that.allShow);
        }
      // window.addEventListener("keydown", this.KeyDown, true)// 监听按键事件
      window.addEventListener("resize", function () {
        //  myChart.resize();
        console.log("xxxx",document.body.clientHeight);
        let ht = document.body.clientHeight
        if( ht >= 1070){
          that.allShow = 1
          console.log("全屏",that.allShow);
        }else{
          that.allShow = 0
          console.log("全屏0",that.allShow);
        }
			});
    },
    methods: {
      goMenu(idx){
        console.log("跳转",idx);
        this.$router.push({
            path:"/dashboard/indexmenus",
            query:{
              id:idx
            }
          })
      },
      KeyDown (event) {
        console.log("event",event);

      if (event.keyCode === 122) {
          //event.returnValue = false
          //this.fullScreen()   //触发全屏的按钮
          this.allShow = false
          console.log("f11");

        }
      },
      clickMenu(path){
        if(path==""){
          this.msgShow = true
          setTimeout(()=>{
            this.msgShow = false
          },1500)
          return
        }
        let token =  Vue.ls.get(ACCESS_TOKEN);
        let url =  path;
        window.open(url, '_blank')
      },
      clickMenu2(path){
        let token =  Vue.ls.get(ACCESS_TOKEN);
        let url =  window._CONFIG['bigscreenUrl']+`/wh-zhshjzx-mx/zhyq-gyjzqzhdn?token=${token}`;
        window.open(url, '_blank')
      }
    }
  }
</script>

<style  lang="less" scoped>
   .box::-webkit-scrollbar { display: none; }
   *{
     padding: 0px;
     margin: 0px;
   }
   body,html{
      overflow-x: hidden;
   }
   .box{
     width: 100%;
     height: 100vh;
     overflow: hidden;
     background: url(../../assets/index_img/bj.png) 60% no-repeat;
   }
   p,h2,span{
     text-shadow: 0px 1px 2px rgba(0,0,0,0.89);
     letter-spacing: 1px;
   }
   .zhuti{
     transform: scale(.9)
   }
   .zhuti2{
     transform: scale(1)
   }
   .header{
     width: 100%;
     height: 90px;
     display: flex;
     justify-content: center;
     align-items: center;
     background: url(../../assets/index_img/nav.png) 60% no-repeat;
     p{
        text-shadow: 0px 0px 7px rgb(16 181 227);
        overflow-wrap: break-word;
        color: rgba(253, 253, 253, 1);
        font-size: 32px;
        letter-spacing: 4px;
        margin: 0px auto 10px;
      }
    }
    #navss{
      margin: 50px auto 0px;
    }
    .nav{
      width: 54%;
      margin: 20px auto 0px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      >div:hover{
        transform: scale(1.1)
      }
      >div{
        width: 347px;
        transition: all .4s linear;
        height: 169px;
        transform: scale(.9);
        cursor: pointer;
        background: url(../../assets/index_img/yun2.png) 60% no-repeat;
        // background: url(../../assets/index_img/yun.png) 60% no-repeat;
        >span{
              height: 17px;
              display: block;
              overflow-wrap: break-word;
              color: rgba(127, 162, 223, 1);
              font-size: 10px;
              text-align: left;
              white-space: nowrap;
              line-height: 15px;
              margin: 29px 0 0 89px;
        }
        >div:nth-of-type(1){
          width: 100%;
          display: flex;
          align-items: center;
          p:first-child{
            width: 100px;
            overflow-wrap: break-word;
            color: rgba(159, 221, 149, 1);
            font-size: 16px;
            text-align: left;
            white-space: nowrap;
            line-height: 26px;
            margin:0px 4px 0px 76px;
          }
          p:last-child{
            overflow-wrap: break-word;
            color: rgba(56, 252, 182, 1);
            font-size: 16px;
            text-align: left;
            white-space: nowrap;
            line-height: 16px;
          }
        }
        >div:nth-of-type(2){
          position: relative;
          display: flex;
          align-items: baseline;
          font-weight: 300;
          p:last-child{
            height: 18px;
            overflow-wrap: break-word;
            color: rgba(60, 131, 192, 1);
            font-size: 18px;
            text-align: left;
            white-space: nowrap;
            line-height: 16px;
          }
          p:first-child{
            height: 45px;
            overflow-wrap: break-word;
            color: rgba(0, 240, 249, 1);
            font-size: 26px;
            text-align: left;
            white-space: nowrap;
            line-height: 42px;
            padding-left: 40px;
            margin-right: 4px;
          }
        }
        >div:nth-of-type(3){
          position: relative;
          p{
            height: 37px;
            overflow-wrap: break-word;
            color: rgba(150, 172, 204, 1);
            font-size: 22px;
            text-align: left;
            white-space: nowrap;
            line-height: 33px;
            font-weight: 300;
            margin: -8px 0 19px 54px;
          }
        }
      }
      .nav2{
        background: url(../../assets/index_img/yun1.png) 60% no-repeat;
        #nav2_p1{
          width: 212px;
          height: 16px;
          overflow-wrap: break-word;
          color: rgba(24, 163, 114, 1);
          font-size: 20px;
          text-align: left;
          white-space: nowrap;
          line-height: 16px;
          font-weight: 300;
          margin: 8px 0 0 71px;
        }
        #nav2_d2{
          justify-content: center;
          p{
            padding: 0px;
            height: 40px;
            line-height: 38px;
          }
        }
        #nav_p2{
            width: 213px;
            height: 36px;
            overflow-wrap: break-word;
            color: rgba(80, 131, 189, 1);
            font-size: 24px;
            text-align: left;
            white-space: nowrap;
            line-height: 36px;
            margin: -10px 0 5px 40px;
        }
        #nav_p3{
            width: 58%;
            display: flex;
            justify-content: space-between;
            height: 17px;
            overflow-wrap: break-word;
            color: rgba(140, 223, 141, 1);
            font-size: 12px;
            text-align: left;
            white-space: nowrap;
            line-height: 17px;
            span:last-child{
              color: rgba(103, 165, 234, 1)
            }
        }
      }
      .nav3{
        background: url(../../assets/index_img/yun3.png) 60% no-repeat;
        #nav2_sp1{
          height: 24px;
            text-align: center;
            margin: 14px 0 0 -40px;
        }
        .nav3_p2{
          line-height: 20px !important;
          height: auto !important;
          color: rgba(53, 111, 204, 1) !important;
        }
        #nav3_p3{
          display: flex;
          p:first-child{
              width: 140px;
              height: 38px;
              overflow-wrap: break-word;
              color: rgba(0, 255, 177, 1);
              font-size: 25px;
              text-align: left;
              white-space: nowrap;
              line-height: 36px;
              margin: -8px 0 19px 40px;
          }
          p:last-child{
              width: 139px;
              height: 28px;
              overflow-wrap: break-word;
              color: rgba(107, 222, 131, 1);
              font-size: 19px;
              text-align: left;
              white-space: nowrap;
              line-height: 26px;
              margin: 10px 0 0 -12px;
          }
        }
      }
    }
    .nav_title{
      width: 54%;
      cursor: pointer;
      margin: 10px auto 0px;
      color: #FDFDFD;
      display: flex;
      justify-content: space-between;
      text-shadow: 0px 1px 1px rgb(48 168 239);
      font-size: 20px;
      padding: 0px 0px 0px;
      text-align: center;
      p{
        width: 347px;
        margin: -10px 0px 0px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        text-shadow: 0px 1px 1px #30A8EF;
        text-align: center;
        letter-spacing: 2px;
      }
    }
    .content{
      width: 70%;
      height: 200px;
      margin: 0px auto;
      position: relative;
      .content_top{
        background: url(../../assets/index_img/up.png) 100% no-repeat;
        position: absolute;
        left: 41%;
        transform: translateX(-50%);
        top: -44px;
        width: 100%;
        height: 290px;
      }
      .content_center{
        height: 300px;
        background-image: url(../../assets/index_img/xuan.png);
        background-size: 100% 100%;
        width: 130px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 180px;
        z-index: 2;
      }
      .dmy{
        width: 337px;
        height: 308px;
        position: absolute;
        left:50%;
        top: 90%;
        transform: translate(-54%, 0%);
        z-index: 1;
        background:url(../../assets/index_img/yu.png) 100% no-repeat
      }
      .content_bottom{
        // background: url(../../assets/index_img/bottom.png) 100% no-repeat;
        position: relative;
        width: 102%;
        height: 325px;
        background-repeat: no-repeat;
        left: -1%;
        bottom: -434px;
        .bjxk{
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: -1;
          left: 0px;
          top: 0px
        }
        // -webkit-transform-style:preserve-3d;
        // animation: haha1 2s linear infinite;
        // vertical-align: middle;
      }
      .content_bottom_box{
        // transform-style: preserve-3d;
        // transform: rotateY(40deg)
      }
      @keyframes haha1 {
      0% {
        transform: rotateY(0deg);
      }

      25% {
        transform: rotateY(90deg);
      }

      50% {
        transform: rotateY(180deg);
      }

      75% {
        transform: rotateY(270deg);
      }

      100% {
        transform: rotateY(360deg);
      }
}
      .content_nav{
        cursor: pointer;
        width: 92%;
        display: flex;
        justify-content: space-between;
        position: absolute;
        left: 50%;
        top: 286px;
        transform: translateX(-52%);
        color: white;
        >div{
          width: 40%;
          height: 92px;
          display: flex;
          padding: 16px 0px;
          flex-wrap: wrap;
          position: relative;
          align-items: center;
          p,span{
            width: 100%;
            padding-right: 100px;
            display: block;
            position: relative;
            z-index: 2;
          }
          p{
            font-size: 22px;
            letter-spacing: 8px;
          }
          span{
            padding-right: 150px;
            letter-spacing: 3px;
          }
        }
        >div:first-child{
          .bqs{
            width: 100%;
            height:100%;
            position: absolute;
            left: 0px;
            top: 0px;
            transform: rotateY(180deg)
          }
          .icon1{
            position: absolute;
            transform: rotateY(180deg);
            right: 50px;
            transition: all 1s linear;
          }
          .icon2{
            position: absolute;
            transform: rotateY(180deg);
            right: 10px;
            transition: all 1s linear;
          }
          p,span{
            text-align: right;
          }
          // background: url(../../assets/index_img/bq.png) 100% no-repeat;
        }
        >div:first-child:hover .icon1,
        >div:first-child:hover .icon2{
          animation: icons 2s linear infinite;
        }
        >div:last-child{
          background: url(../../assets/index_img/bq.png) 100% no-repeat;
          .icon1{
            position: absolute;
            left: 90px;
            transition: all 1s linear;
          }
          .icon2{
            position: absolute;
            left: 55px;
            transition: all 1s linear;
          }
          p,span{
            text-align: left;
            padding:0px 0px 0px 150px;
          }
          span{
            padding:0px 0px 0px 200px;
          }
        }
        >div:last-child:hover .icon1,
        >div:last-child:hover .icon2{
          animation: icons2 2s linear infinite;
        }
      }
      @keyframes icons {
        0% {
          opacity: 0;
          transform: scale(.6) rotateY(180deg);
        }
        50%{
          opacity: 0.5;
          transform: scale(.8) rotateY(180deg);
        }
        100% {
          opacity: 1;
          transform: scale(1) rotateY(180deg);
        }
      }
      @keyframes icons2 {
        0% {
          opacity: 0;
          transform: scale(.6);
        }
        50%{
          opacity: 0.5;
          transform: scale(.8);
        }
        100% {
          opacity: 1;
          transform: scale(1);
        }
      }
      .content_bottom{
        .x1{
          position: absolute;
          left: 188px;
          top: 40px;
          width: 418px;
          height: 72px;
          background: url(../../assets/index_img/x1.png) 0px -1px no-repeat;
        }
        .x2{
          height: 127px;
          background: url(../../assets/index_img/x2.png) 100% no-repeat;
          background-size: 100% 100%;
          width: 261px;
          position: absolute;
          left: 376px;
          top: 49px;
        }
        .x3{
          height: 150px;
          background: url(../../assets/index_img/x3.png) 100% no-repeat;
          background-size: 100% 100%;
          width: 100px;
          margin: -3px 0 0 213px;
          position: absolute;
          left: 382px;
          top: 56px;
        }
        .x4{
          height: 150px;
          background: url(../../assets/index_img/x4.png) 100% no-repeat;
          background-size: 100% 100%;
          width: 100px;
          margin: -3px 0 0 213px;
          position: absolute;
          left: 500px;
          top: 56px;
        }
        .x5{
          background: url(../../assets/index_img/x5.png) 100% no-repeat;
          height: 127px;
          background-size: 100% 100%;
          width: 261px;
          position: absolute;
          left: 740px;
          top: 54px;
        }
        .x6{
          position: absolute;
          left: 770px;
          top: 46px;
          width: 418px;
          height: 72px;
          background: url(../../assets/index_img/x6.png) 0px -1px no-repeat;
          background-size: 418px 73px;
        }
        .neirong1:hover>img{
          top:-10px
        }
        .neirong1{
          width: 118px;
          cursor: pointer;
          height: 97px;
          position: absolute;
          left: 80px;
          top: 50px;
          background: url(../../assets/index_img/di.png) 0px -1px no-repeat;
          img{
           margin: 0px auto;
           position: absolute;
           left: 27px;
           top: 0px;
           transition: all .3s linear
          }
          p{
            width: 140px;
            position: initial;
            bottom: -24px;
            transform: translateX(-9%) !important;
            color: white;
            font-size: 22px;
            text-align: center;
            text-shadow: 0px 1px 2px rgba(0,0,0,0.89);
            padding: 88px 0px 0px
          }
        }
        .neirong2{
            left: 306px;
            top: 122px;
        }
        .neirong3{
            left: 536px;
            top: 140px;
        }
        .neirong4{
            left: 748px;
            top: 140px;
        }
        .neirong5{
            left: 944px;
            top: 124px;
        }
        .neirong6{
            left: 1140px;
            top: 70px;
        }
      }
    }
    .msg_tx{
      position: absolute;
      left: 50%;
      top: -60px;
      color: white;
      transition: all .4s linear;
      background: RGBA(20, 29, 39, .4);
      padding: 20px 40px;
      transform: translateX(-50%)
    }
    #msg_tx{
      top: 80px;
    }
</style>